import { Box, styled } from '@mui/material'
import InviteRentalList from '@src/components/orbitalTrack/rentalSetting/inviteRental/InviteRentalList'
import InviteRentalNew from '@src/components/orbitalTrack/rentalSetting/inviteRental/InviteRentalNew'
import PublicRentalEdit from '@src/components/orbitalTrack/rentalSetting/publicRental/PublicRentalEdit'
import PublicRentalNew from '@src/components/orbitalTrack/rentalSetting/publicRental/PublicRentalNew'
import { useOrbitalTrackAttachContext } from '@src/contexts/orbitalTrack/OrbitalTrackAttachContext'
import * as R from 'ramda'
import { FC } from 'react'

const Container = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 50px;
`

const RentalSection: FC<Props> = props => {
  const { className } = props

  const { trackDetail } = useOrbitalTrackAttachContext()

  const publicTracks = R.pathOr(0, ['openSetting', 'totalTrack'], trackDetail)

  return (
    <Container className={className}>
      {publicTracks === 0 ? <PublicRentalNew /> : <PublicRentalEdit />}
      {trackDetail && trackDetail?.inviteSettings.length === 0 ? (
        <InviteRentalNew />
      ) : (
        <InviteRentalList />
      )}
    </Container>
  )
}

type Props = {
  className?: string
}

export default RentalSection
